module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGAAAABgCAMAAADVRocKAAAATlBMVEUAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADEoqZZAAAAGnRSTlMAJIPH3/+/exgEk/v3o5swi7ssj9fj50CzDJqv/RQAAADBSURBVHgB7dVFgsQwAANBBWQPM/7/o3s3LWlYdQt20MbPmFnXDyMTY4gTaExncxYtIhSmgVVLCKzYILiHNVsWE/UN6G9hZFPAf7FtlAXa6x1w4G0Cybj/B+15YrqZU2IRUTLdUmaJghmFIjK7OQUa88SeUhGpA6UCUgtKjUhRzAEHHHDAAQEHHHDAAQcccMABBxxwQOWI1IlSA1JLSvVInak075C5UGiG3PVAmTBFqSC7h9UUZeel4FsaV2uYmT2ZL8xFZerFxIuvAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/weight-icon.png
// module id = 361
// module chunks = 0